import { PostoCombutivel } from "../model/entities/PostoCombustivel";
import { ResponseGenericType } from "../model/types/ResponseType";
import api from "./api";

const ROUTE = "posto-combustivel";

class postoCombustivelApi {
  async getMany(pagina: number, linhasPorPagina: number) {
    try {
      const res = await api.get<ResponseGenericType<PostoCombutivel[]>>(
        `/${ROUTE}?size=${linhasPorPagina}&page=${pagina}`
      );
      const data = res.data.content;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getManyComplete() {
    try {
      const res = await api.get<PostoCombutivel[]>(`/${ROUTE}/complete`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async insert(perfil: PostoCombutivel) {
    try {
      const res = await api.post<PostoCombutivel>(`/${ROUTE}`, perfil);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async update(idPerfil: number, perfil: PostoCombutivel) {
    try {
      const res = await api.put<PostoCombutivel>(
        `/${ROUTE}/${idPerfil}`,
        perfil
      );
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiPostoCombustivel = new postoCombustivelApi();
export default apiPostoCombustivel;
